<template>
  <div>
    <div class="container-fluid bg-light py-6 mt-0">
      <div class="container text-center animated bounceInDown">
        <h1 class="display-1 mb-4">{{ $t('blogs') }}</h1>
        <ol
          class="breadcrumb justify-content-center mb-0 animated bounceInDown"
        >
          <li class="breadcrumb-item"><a href="#">{{ $t('home') }}</a></li>
          <li class="breadcrumb-item text-dark" aria-current="page">{{ $t('blogs') }}</li>
        </ol>
      </div>
    </div>
    <div class="container-fluid blog py-6">
      <div class="container">
        <div class="text-center wow bounceInUp" data-wow-delay="0.1s">
          <small
            class="d-inline-block fw-bold text-dark text-uppercase bg-light border border-primary rounded-pill px-4 py-1 mb-3"
            >{{ $t('ourBlogs') }}</small
          >
          <h1 class="display-5 mb-5">{{ $t('blogPageTitle') }}</h1>
        </div>
        <div class="row gx-4 justify-content-center">
          <div
            v-for="blog in blogs"
            :key="blog.id"
            class="col-md-6 col-lg-4 col-sm-12 wow bounceInUp"
            data-wow-delay="0.1s"
          >
            <div class="blog-item">
              <div class="overflow-hidden rounded">
                <img
                  :src="getImageUrl(blog.cover_photo_url)"
                  class="img-fluid w-100"
                  alt=""
                  style="height: 400px !important; object-fit: contain;"
                />
              </div>
              <div class="blog-content mx-4 d-flex rounded bg-light">
                <div class="text-dark bg-primary rounded-start">
                  <div
                    class="h-100 p-3 d-flex flex-column justify-content-center text-center"
                  >
                    <p class="fw-bold mb-0">{{ formatBlogDate(blog).day }}</p>
                    <p class="fw-bold mb-0">{{ formatBlogDate(blog).month }}</p>
                  </div>
                </div>
                <router-link
                  :to="{ name: 'BlogDetail', params: { id: blog.id } }"
                  class="h5 lh-base my-auto h-100 p-3"
                >
                {{ getLocalizedTitle(blog) }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import mediaUrl from "../utils/mediaUrl";

export default {
  methods: {
    ...mapActions(["getBlogs"]),
    getImageUrl(imageUrl) {
      return mediaUrl(imageUrl);
    },
    formatBlogDate(blog) {
      const date = new Date(blog.created_at);
      const day = date.getDate().toString().padStart(2, "0");
      const month = date.toLocaleString("default", { month: "short" });
      return {
        day,
        month,
      };
    },
    getLocalizedTitle(blog) {
      const locale = this.$i18n.locale;
      if (locale === 'en') return blog.title_en ? blog.title_en : blog.title_en;
      if (locale === 'mm') return blog.title_mm ? blog.title_mm : blog.title_en;
      if (locale === 'jp') return blog.title_jp ? blog.title_jp : blog.title_en;
    }
  },
  computed: mapGetters(["blogs"]),
  mounted() {
    this.getBlogs();
  },
};
</script>

<style></style>
